import { render } from "./CookiesBanner.vue?vue&type=template&id=076f719a&ts=true"
import script from "./CookiesBanner.ts?vue&type=script&lang=ts&external"
export * from "./CookiesBanner.ts?vue&type=script&lang=ts&external"

import "./CookiesBanner.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__